import React, { PropsWithChildren, useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { darkModePalette, getBaseThemeOptions, lightModePalette } from "../../theme/Theme";
import { useCustomer } from "../../provider/Customer/CustomerProvider";

export let darkModeTheme = createTheme({
  palette: darkModePalette,
});

darkModeTheme = createTheme({
  ...darkModeTheme,
  ...getBaseThemeOptions(darkModeTheme),
});

export let lightModeTheme = createTheme({
  palette: lightModePalette,
});

lightModeTheme = createTheme({
  ...lightModeTheme,
  ...getBaseThemeOptions(lightModeTheme),
});

export default function ThemeProviderWrapper({ children }: PropsWithChildren) {
  const { customer } = useCustomer();
  const [selectedTheme, setSelectedTheme] = useState<"light" | "dark">("light");

  useEffect(() => {
    if (selectedTheme === customer?.userConfig?.theme) {
      return;
    }
    setSelectedTheme(customer?.userConfig?.theme || "light");
  }, [customer?.userConfig?.theme]);

  // ? in userConfig? is only temporary since there might be old customers in users localstorage
  return <ThemeProvider theme={selectedTheme === "light" ? lightModeTheme : darkModeTheme}>{children}</ThemeProvider>;
}
